import PropTypes from 'prop-types';
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { trackEvent } from 'dibs-tracking';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { localStorage } from 'dibs-browser-storage';

import { actionCreators } from '../../../actions';
import CurrencyDropdown from './CurrencyDropdown';
import ChangeCurrencyMutation from './ChangeCurrencyMutation';

class CurrencySelector extends React.Component {
    constructor(props) {
        super(props);

        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
    }

    componentDidMount() {
        const currency = localStorage.getItem('userCurrency');
        this.props.setCurrencyUpdated(false);
        this.props.setCurrency(currency);
    }

    updateCurrency(currency) {
        if (this.props.user) {
            ChangeCurrencyMutation.commit({
                environment: this.props.relay.environment,
                user: this.props.user,
                currency,
                onCompleted: () => {
                    this.props.setCurrency(currency);
                    this.props.setCurrencyUpdated(true);
                    localStorage.setItem('userCurrency', currency);
                    window.location.reload();
                },
            });
        } else {
            this.props.setCurrency(currency);
            this.props.setCurrencyUpdated(true);
            localStorage.setItem('userCurrency', currency);
            window.location.reload();
        }
    }

    handleCurrencyChange(currency) {
        const category = 'navigation';
        const action = 'footer navigation click';
        const label = `change currency|${currency.toLowerCase()}`;
        const value = 0;
        const additional = { defaultCurrency: `${currency} Selected` };

        trackEvent({ category, action, label, value, additional });

        this.updateCurrency(currency);
    }

    render() {
        const currencies = get(this.props, 'viewer.currencies', []);
        const currency = get(this.props, 'user.profile.currency') || this.props.userCurrency;

        return (
            <CurrencyDropdown
                onChange={this.handleCurrencyChange}
                currencies={currencies}
                currency={currency}
            />
        );
    }
}

CurrencySelector.propTypes = {
    relay: PropTypes.object,
    viewer: PropTypes.object,
    user: PropTypes.object,
    userCurrency: PropTypes.string,
    setCurrency: PropTypes.func,
};

CurrencySelector.defaultProps = {
    userCurrency: 'USD',
};

const mapStateToProps = state => {
    const userCurrency = get(state, 'footer.userCurrency');

    return { userCurrency };
};

const mapDispatchToProps = dispatch => {
    return {
        setCurrency: currency => {
            dispatch(actionCreators.setCurrency(currency));
        },
        setCurrencyUpdated: currencyUpdated => {
            dispatch(actionCreators.setCurrencyUpdated(currencyUpdated));
        },
    };
};

export default createFragmentContainer(
    connect(mapStateToProps, mapDispatchToProps)(CurrencySelector),
    {
        viewer: graphql`
            fragment CurrencySelector_viewer on Viewer {
                currencies
            }
        `,
        user: graphql`
            fragment CurrencySelector_user on User {
                id
                serviceId
                profile {
                    currency
                }
            }
        `,
    }
);
